<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters pb-5">
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search anything here ..." single-line solo
            hide-details></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="2">
          <v-select v-model="selectedCreditType" solo :items="creditTypes" append-icon="mdi-chevron-down"
            label="Credit Type" class="custom-select" @change="handleSelectChange"></v-select>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="3">
          <v-dialog ref="dialog" v-model="modal" :return-value.sync="dateRange" width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="selectedDatesText" prepend-icon="mdi-calendar" append-icon="mdi-chevron-down"
                readonly v-bind="attrs" v-on="on" solo class="custom-select" label="Date Range"></v-text-field>
            </template>
            <v-date-picker v-model="selectedDates" class="custom-date-picker" scrollable range>
              <v-spacer></v-spacer>
              <v-btn text @click="cancelSelection">Cancel</v-btn>
              <v-btn text @click="confirmSelection">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-col>
        <v-col cols="12" sm="6" md="6" lg="4">
          <ul>
            <li>
              <span>Credit In:</span>
              <span>{{ totalcreditIn }}</span>
            </li>
            <li>
              <span>Credit Out:</span>
              <span>{{ totalcreditOut }}</span>
            </li>
            <li v-if="$canRoute('credit-in-out-reg-tab') === 1">
              <v-dialog transition="scale-transition" origin="center center" max-width="460" v-model="dialogDeposit"
                content-class="deposit-withdraw-popup marketingPopup">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn tile elevation="0" class="text-capitalize" color="#039de9" v-bind="attrs" v-on="on">
                    <v-icon> mdi mdi-credit-card-outline </v-icon>
                    Credit In / Out
                  </v-btn>
                </template>
                <v-card class="rounded-0 pa-7" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                  <v-card-title class="pb-3 text-left justify-start pl-3">
                    Credit In / Out
                  </v-card-title>
                  <v-card-subtitle class="mt-0 pl-3 pb-0 pr-10 text--ash">
                    Transfer Credit From Here
                  </v-card-subtitle>
                  <v-card class="deposit-form px-3 py-4"
                    :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                    <v-row>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Transaction Type*</legend>
                          <v-select v-model="selectedTrxType" solo :items="trx_type" item-text="text" item-value="value"
                            append-icon="mdi-chevron-down" label="Click to Select" class="custom-select"
                            hide-details></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>MT5 Account*</legend>
                          <v-select v-model="selectedAccount" solo :items="tradingAcc" item-text="text"
                            item-value="value" append-icon="mdi-chevron-down" label="Select Your Acc."
                            class="custom-select" hide-details @change="updateCurrencyName"></v-select>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" :cols="currency.name !== 'USD' ? 6 : 12">
                        <fieldset>
                          <legend>Amount*</legend>
                          <v-text-field type="number" min="1" v-model="amount" label="USD" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="6" v-if="currency.name !== 'USD'">
                        <fieldset>
                          <legend>Amount in <span :style="{color:currency.color}">({{ currency.name }})</span></legend>
                          <v-text-field disabled :value="amount * currency.rate" label="Enter Amount" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                      <v-col cols="12">
                        <fieldset>
                          <legend>Comment*</legend>
                          <v-text-field v-model="comment" label="Write Here" single-line solo hide-details
                            class="custom-select"></v-text-field>
                        </fieldset>
                      </v-col>
                    </v-row>
                  </v-card>
                  <v-card-actions>
                    <v-row dense>
                      <v-col cols="12">
                        <v-btn tile @click.prevent="submitForm" :loading="loading" :disabeled="loading" elevation="0" class="text-capitalize btn-account mr-3 px-sm-8"
                          color="greenMain">Confirm</v-btn>
                        <v-btn tile color="#FF567F" @click="dialogDeposit = false" elevation="0"
                          class="text-capitalize btn-account px-sm-8">Cancel</v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </li>
          </ul>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
        <v-data-table :headers="headers" :items-per-page="5" :items="clientCreditInOuts"></v-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  REGISTERUSERDETAILS__ACTIONS
} from "@/store/action-types";

export default {
  data() {
    return {
      loading: false,
      headers: [
        { text: "SL No.", align: "start", value: "SL_No" },
        { text: "Date and Time", value: "Date_and_Time" },
        { text: "Trx. Type", value: "Trx_Type" },
        { text: "Trading Account", value: "Account" },
        { text: "Amount ($)", value: "Amount" },
        { text: "Comment", value: "Comment" },
      ],
      search: "",
      creditTypes: [
        { text: "All", value: null },
        { text: "Credit In", value: 0 },
        { text: "Credit Out", value: 1 }
      ],
      modal: false,
      dialogDeposit: false,
      transferType: null,
      transferTypes: [
        { text: "Credit In", value: "In" },
        { text: "Credit Out", value: "Out" }
      ],
      currency:{
        name: 'USD',
        rate: 1,
        color: '#fff'
      },
      dateRange: {},
      selectedAccount: null,
      mt5Accounts: [],
      userId: "",
      trx_type: [
        { text: "Credit In", value: 0 },
        { text: "Credit Out", value: 1 },
      ],
      selectedTrxType: null,
      selectedAccount: null,
      amount: null,
      comment: "",
      selectedDates: [],
      selectedDatesText: null,
      selectedCreditType: null,
    };
  },

  computed: {
    ...mapState("reguserdetails", ["clientCreditInOuts", "totalcreditIn", "totalcreditOut", "tradingAcc"]),
    ...mapState("admins", ["loggedAdmin"]),

    updateCurrencyName(selectedAccount) {
      const account = this.tradingAcc.find(acc => acc.value === this.selectedAccount);
      this.currency.name = account ? account.currency_name : 'USD';
      this.currency.rate = account ? account.currency_rate : 1;
      this.currency.color = account ? account.currency_color : '#fff';
    },

  },

  methods: {
    ...mapActions("reguserdetails", [
      REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT,
      REGISTERUSERDETAILS__ACTIONS.PERFORMCREDITTRANSFER, REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS, REGISTERUSERDETAILS__ACTIONS.CREATECLIENTCREDITINOUT
    ]),

    async submitForm() {
      this.loading = true;
      try{
        const formData = {
        client_account_id: this.userId,
        credit_type: this.selectedTrxType,
        trading_account_no: this.selectedAccount,
        amount: this.amount,
        comment: this.comment
        };
        await this[REGISTERUSERDETAILS__ACTIONS.CREATECLIENTCREDITINOUT](formData)
        this.dialogDeposit = false;
        this.selectedTrxType = '';
        this.selectedAccount = '';
        this.amount = '';
        this.comment = '';
      }catch(error){
        console.error("Server Error: " +error);
      }finally{
        this.loading = false;
      }
    },

    confirmTransfer() {
      // Perform validation
      if (!this.transferType || !this.selectedAccount || !this.amount) {
        // Show error message
        return;
      }

      // Call action to perform credit transfer
      this[REGISTERUSERDETAILS__ACTIONS.PERFORMCREDITTRANSFER]({
        type: this.transferType,
        account: this.selectedAccount,
        amount: parseFloat(this.amount),
        comment: this.comment
      }).then(() => {
        // Handle successful transfer
        this.dialogDeposit = false;
        // Refresh the credit in/out data
        this[REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT](this.$route.params.id);
      }).catch(error => {
        // Handle error
        console.error("Transfer failed:", error);
      });
    },

    handleSelectChange() {
      const parameter = {
        credit_type: this.selectedCreditType,
        client_account_id: this.userId,
      };
      this[REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT](parameter);
    },

    getCurrentDate() {
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString().split("T")[0];
      return formattedDate;
    },

    cancelSelection() {
      this.modal = false;
    },

    confirmSelection() {
      if (this.selectedDates.length !== 2) {
        console.error("Both start and end dates must be selected");
        return;
      }

      let startDate = new Date(this.selectedDates[0]);
      let endDate = new Date(this.selectedDates[1]);

      if (startDate > endDate) {
        [startDate, endDate] = [endDate, startDate];
      }

      const parameter = {
        client_account_id: this.userId,
        duration: `${startDate.toISOString().split("T")[0]}to${endDate.toISOString().split("T")[0]
          }`,
      };
      console.log('parameter', parameter)
      this[REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT](parameter);

      this.modal = false;
      this.selectedDates = [startDate, endDate];
      this.selectedDatesText = this.selectedDates
        .map((date) => date.toISOString().split("T")[0])
        .join(" ~ ");
    },
  },

  async mounted() {
    this.userId = this.$route.params.id;
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTCREDITINOUT]({ client_account_id: this.$route.params.id });
    await this[REGISTERUSERDETAILS__ACTIONS.CLIENTTRADINGACCOUNTS](this.$route.params.id);
    this.selectedDatesText = [
      this.getCurrentDate(),
      this.getCurrentDate(),
    ].join(" ~ ");
  },
};
</script>